export const userQueryKeys = {
  all: ["users"] as const,
  lists: () => [...userQueryKeys.all, "list"] as const,
  roles: () => [...userQueryKeys.all, "roles"] as const,
  filters: () => [...userQueryKeys.all, "filters"] as const,
};
